import { render, staticRenderFns } from "./businessmain.vue?vue&type=template&id=b7e3461c&scoped=true"
import script from "./businessmain.vue?vue&type=script&lang=js"
export * from "./businessmain.vue?vue&type=script&lang=js"
import style0 from "./businessmain.vue?vue&type=style&index=0&id=b7e3461c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e3461c",
  null
  
)

export default component.exports